/* Routing */
import { Link } from "react-router-dom";
import Icon from "../Icon";

export default function TabsNavigation({ category }) {

    const sources = "fa fa-bars";
    return (
        <nav className="tabs-menu">
            <ul>
                <li className={(category === 1) && "active"}><Link to="/admin/cms/demarches">Les démarches</Link></li>
                <li className={category === 3 && "active"}><Link to="/admin/cms/mentions/legales">Mentions légales</Link></li>
                <li className={category === 4 && "active"}><Link to="/admin/cms/cookies">Cookies</Link></li>
                <li className={category === 5 && "active"}><Link to="/admin/cms/rgpd">Données personnelles</Link></li>
                <li className={category === 6 && "active"}><Link to="/admin/cms/formulaires">Texte formulaires</Link></li>
            </ul>
        </nav>
    )
}

